import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.9971 16.9287L23.0088 17.0879L22.9697 17.2422L21.9697 21.2422L21.7812 22H2.21875L2.03027 21.2422L1.03027 17.2422L0.991211 17.0879L1.00293 16.9287L2.06934 2H21.9307L22.9971 16.9287ZM3.78027 20H20.2197L20.7197 18H3.28027L3.78027 20ZM5.5 13.5H18.5V11.5H5.5V13.5ZM5.5 9H18.5V7H5.5V9Z"}}]};

const Collection1Filled = Vue.extend<IconProps>({
  name: 'Collection1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'collection-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Collection1Filled;
